<template>
    <div id="StoreHours" style="width: 250px;">
      <div
        v-for="(storeHours, index) in getStoreHours" :key="index"
        class="store-hours"
        :class="{ 'today': isToday(index) }"
        style="margin: 8px 0px; padding: 2px 8px"
      >
        <div style="text-align: left; display: inline-block; float: left">
          {{ storeHours.day }}
        </div>
  
        <div style=" text-align: right; display: block">
          <template v-if="storeHours.open">
            {{ storeHours.open }}
          </template>
          <template v-if="storeHours.close">
            - {{ storeHours.close }}
          </template>
        </div>
     </div>
    </div>
  </template>
  
  <style scoped>
    * {
      font-size: var(--text-size-1);
      color: var(--footer-text) !important;
    }
    .today {
      border-top: 1px var(--v-info-base) solid;
      border-bottom: 1px var(--v-info-base) solid;
      font-weight: 700;
    }
  </style>
  
  <script>
    import { getStoreHoursMassaged } from "@/plugins/util"
  
    export default {
      props: {
        store: {
          type: Object,
          default: () => ({})
        }
      },
  
      computed: {
        getStoreHours() {
          return getStoreHoursMassaged(this.store)
        },
  
        todayDay() {
          const dt = new Date()
          dt.setHours(0)
          dt.setMinutes(0)
          dt.setSeconds(0)
  
          return dt.getDay()
        }
      },
  
      methods: {
        isToday(day) {
          return day == this.todayDay
        }
      }
    }
  </script>
  <style>
.store-hours {
 color: white;
}
</style>
  